import React from "react";

const news = () => {
    return (


        <section className="section-padding offer-section">
            <div className="container">
                <div className="row">
                    <div className="col col-md-5">
                        <div className="section-title-s3">
                            <h2>ساخت و بروزرسانی دستگاه های بومی صنعت نساجی با فناوری دانش محور و پرسنل متخصص و با تجربه</h2>
                        </div>
                        <div className="offer-text">
                            <p>شرکت تعاوني دانش بنيان آپافن با شعار تولید ایرانی، کیفیت جهانی و مجوز فناوری دانش بنیان شروع فعاليت خود را در پارک علم و فناوري يزد از سال ۱۳۹۰ آغاز نموده است.</p>
                            <p>این شرکت با ساخت ماشین آلات صنعتی به مدت یک دهه سابقه فعالیت و همگام با استاندارد جهانی در بازار شناخته شده است و توانسته است در این زمینه موقعیت خود را تثبیت نماید. </p>
                            <a href="#about" className="theme-btn read-more">بیشتر بدانید</a>
                            {/* <a href="#" className="theme-btn-s2 read-more">تاریخچه شرکت</a> */}
                        </div>
                    </div>
                    <div className="col col-md-7">
                        <div className="offer-pic">
                            <img src="assets/images/offer-pic.jpg" alt='' role='presentation' />
                        </div>
                    </div>
                </div>
            </div>
        </section>


    );
};

export default news; 